import { apiSlice } from 'src/features/api/api-slice';
import { ApiResponse } from 'src/common/interfaces';
import { RTKQueryTag } from 'src/common/constants';
import { AzureConfigDocument, Upload } from 'src/common/interfaces/uploads';

import { AzureTenantOnboardingCompanyData, AzureTenantOnboardingUpdateBody } from './azure-tenant-onboarding.types';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createLab: builder.mutation<ApiResponse, AzureConfigDocument>({
      query: (body) => ({
        url: `admin/cloud/azure/labs`,
        method: 'POST',
        body,
      }),
      invalidatesTags: [RTKQueryTag.AzureLabs],
    }),
    deleteLab: builder.mutation<ApiResponse, { uploadId: string }>({
      query: ({ uploadId }) => ({
        url: `admin/cloud/azure/labs`,
        method: 'DELETE',
        params: {
          uploadId,
        },
      }),
      invalidatesTags: [RTKQueryTag.AzureLabs],
    }),
    getLabs: builder.query<Upload[], void>({
      query: () => 'admin/cloud/azure/labs',
      transformResponse: (response: ApiResponse<Upload[]>) => response.data ?? [],
      providesTags: [RTKQueryTag.AzureLabs],
    }),
    updateLab: builder.mutation<ApiResponse, { uploadId: string; body: Partial<AzureConfigDocument> }>({
      query: (arg) => ({
        url: `admin/cloud/azure/labs`,
        method: 'PUT',
        params: {
          uploadId: arg.uploadId,
        },
        body: arg.body,
      }),
      invalidatesTags: [RTKQueryTag.AzureLabs],
    }),
    getCompaniesForAzureTenantOnboarding: builder.query<ApiResponse<AzureTenantOnboardingCompanyData[]>, void>({
      query: () => `admin/companies/companies-for-azure-tenant-onboarding`,
      providesTags: [RTKQueryTag.AzureTenantOnboardingCompanies],
    }),
    updateTenantLabDetails: builder.mutation<ApiResponse, AzureTenantOnboardingUpdateBody>({
      query: (arg) => ({
        url: `admin/cloud/azure/update-tenant-lab-details`,
        method: 'PATCH',
        body: arg,
      }),
      invalidatesTags: [RTKQueryTag.AzureTenantOnboardingCompanies],
    }),
    requestAzureLab: builder.mutation<ApiResponse, { companyId: string }>({
      query: (arg) => ({
        url: `/companies/request-azure-tenant-lab`,
        method: 'POST',
        body: arg,
      }),
      invalidatesTags: [RTKQueryTag.Company],
    }),
  }),
});

export const {
  useCreateLabMutation,
  useDeleteLabMutation,
  useGetLabsQuery,
  useGetCompaniesForAzureTenantOnboardingQuery,
  useUpdateTenantLabDetailsMutation,
  useUpdateLabMutation,
  useRequestAzureLabMutation,
} = extendedApiSlice;
